import React from "react";

import { Sheet, Stack, Theme, Typography } from "@mui/joy";
import { TableViewOutlined } from "@mui/icons-material";

import { tryParseJson } from "../util/dataUtil";
import { MessageProps } from "../shared/props";

export default function GenerateSpreadsheetMessage(props: MessageProps) {
    const functionMessageContainerStyle = (theme: Theme) => ({
        borderRadius: theme.radius.md,
        padding: 2,
        width: "auto",
        maxWidth: "500px",
        alignSelf: props.singleMessageView ? "flex-start" : "flex-end",
    });

    const msg = props.message;
    const messageKey = "message-" + msg.id;
    const jsonParsed = tryParseJson(msg.message);

    return (
        <Sheet variant="outlined" key={messageKey} sx={functionMessageContainerStyle}>
            <Stack spacing={2}>
                <Typography level="title-sm" color="primary" startDecorator={<TableViewOutlined />}>
                    Generate spreadsheet
                </Typography>

                <Typography>
                    <Typography level="title-sm">Data:</Typography> {jsonParsed.data.dataToExtract}
                </Typography>
            </Stack>
        </Sheet>
    );
}
